<template>
  <div class="main help-page">
    <div class="main_r">
      <div class="page-top">
        <div class="title_line">帮助中心列表</div>

        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">问题</label>
              <el-input v-model="queryData.question" placeholder="输入问题" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">回答</label>
              <el-input v-model="queryData.answer" placeholder="输入回答" clearable size="small"></el-input>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">分类</label>
              <el-select v-model="queryData.category" placeholder="全部" size="small">
                <el-option label="全部" value=""></el-option>
                <el-option label="硬件相关" value="hardware"></el-option>
                <el-option label="软件相关" value="software"></el-option>
                <el-option label="配件相关" value="accessory"></el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">起始时间</label>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">结束时间</label>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
            <span class="filter-strip__sep"></span>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="clickdialogAdd">新增</el-button>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="table-section">
        <div class="table-container" ref="tableContainer">
          <el-table
            :data="dataList"
            class="help-table"
            :height="tableHeight"
            :header-cell-style="tableHeaderStyle"
            :cell-style="tableCellStyle"
            @sort-change="handleSortChange">
            <el-table-column type="index" label="序号" width="80" fixed="left" align="center" :index="tableIndexMethod"></el-table-column>
            <el-table-column prop="question" label="问题" min-width="180" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="answer" label="回答" min-width="200" sortable="custom" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cover" label="封面" width="100" align="center">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.cover"
                  style="width: 50px; height: 50px; border-radius: 4px; overflow: hidden;"
                  :src="getImageUrl(scope.row.cover)"
                  :preview-src-list="[getImageUrl(scope.row.cover)]"
                  fit="cover">
                </el-image>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="category" label="分类" width="110" sortable="custom" align="center" class-name="col-tag">
              <template slot-scope="scope">
                <el-tag
                  v-if="categoryTagMap[scope.row.category]"
                  size="small"
                  effect="plain"
                  :type="categoryTagMap[scope.row.category].type"
                  :closable="false">
                  {{ categoryTagMap[scope.row.category].label }}
                </el-tag>
                <span v-else class="text-muted">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="170" sortable="custom" show-overflow-tooltip class-name="col-mono"></el-table-column>
            <el-table-column label="英文问题" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="text-secondary">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['question']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="德文问题" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="text-secondary">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['question']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Operation" label="操作" width="140" fixed="right" align="center">
              <template slot-scope="scope">
                <div class="action-group">
                  <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickdialogEdit(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                    <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="翻译" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-link>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="page_size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="dataListnum">
        </el-pagination>
      </div>
    </div>

    <!---------------------- 以下是弹框内容 ---------------------->
    <!-- 新增 -->
    <el-dialog title="添加帮助" :visible.sync="dialogAdd" width="640px" class="newAdd" :close-on-click-modal="false">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="addData" label-width="80px">
          <el-form-item label="问题" :required="true">
            <el-input v-model="addData.question" placeholder="请输入问题"></el-input>
          </el-form-item>
          <el-form-item label="回答" :required="true">
            <el-input type="textarea" :rows="4" v-model="addData.answer" placeholder="请输入回答"></el-input>
          </el-form-item>
          <el-form-item label="分类" :required="true">
            <el-select v-model="addData.category" placeholder="请选择分类" style="width: 100%">
              <el-option label="硬件相关" value="hardware"></el-option>
              <el-option label="软件相关" value="software"></el-option>
              <el-option label="配件相关" value="accessory"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面图片">
            <el-upload
              class="cover-uploader"
              :action="''"
              :http-request="handleAddUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :auto-upload="true">
              <img v-if="addData.cover" :src="getImageUrl(addData.cover)" class="cover-image">
              <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="HelpCenterInsert()" >确定</el-button>
        <el-button @click="dialogAdd = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 新增 End -->

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="640px" class="newAdd" :close-on-click-modal="false">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="80px">
          <el-form-item label="问题" :required="true">
            <el-input v-model="editData.question" placeholder="请输入问题"></el-input>
          </el-form-item>
          <el-form-item label="回答" :required="true">
            <el-input type="textarea" :rows="4" v-model="editData.answer" placeholder="请输入回答"></el-input>
          </el-form-item>
          <el-form-item label="分类" :required="true">
            <el-select v-model="editData.category" placeholder="请选择分类" style="width: 100%">
              <el-option label="硬件相关" value="hardware"></el-option>
              <el-option label="软件相关" value="software"></el-option>
              <el-option label="配件相关" value="accessory"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面图片">
            <el-upload
              class="cover-uploader"
              :action="''"
              :http-request="handleEditUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :auto-upload="true">
              <img v-if="editData.cover" :src="getImageUrl(editData.cover)" class="cover-image">
              <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="HelpCenterUpdate()" >确定</el-button>
        <el-button @click="dialogEdit = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑信息 End -->

    <!-- 翻译管理 -->
    <i18n-translation-dialog
      :visible.sync="dialogI18n"
      :entity-type="i18nEntityType"
      :entity-id="i18nEntityId"
      :fields="i18nFields">
    </i18n-translation-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    I18nTranslationDialog
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        question: '',
        answer: '',
        category: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        question: '',
        answer: '',
        cover: '',
        category: ''
      },
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/file',
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        question: '',
        answer: '',
        cover: '',
        category: ''
      },
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'HELP_CENTER',
      i18nFields: [
        { name: 'question', label: '问题', type: 'input' },
        { name: 'answer', label: '回答', type: 'textarea' }
      ],
      translationMap: {},
      categoryTagMap: {
        hardware: { type: 'primary', label: '硬件相关' },
        software: { type: 'success', label: '软件相关' },
        accessory: { type: 'warning', label: '配件相关' }
      }
    }
  },
  mounted () {
    this.HelpCenterList()
    this.HelpCenterNum()
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.type === 'index' || column.property === 'Operation' || column.property === 'category' || column.property === 'cover') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    tableIndexMethod (index) {
      const seq = (this.page_no - 1) * this.page_size + index + 1
      if (this.sortOrder === 'asc') {
        return seq
      }
      return this.dataListnum - seq + 1
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    clickQuery () {
      this.page_no = 1
      this.HelpCenterList()
      this.HelpCenterNum()
    },
    clickQueryReset () {
      this.queryData.question = ''
      this.queryData.answer = ''
      this.queryData.category = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.question = ''
      this.addData.answer = ''
      this.addData.cover = ''
      this.addData.category = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.question = row.question
      this.editData.answer = row.answer
      this.editData.cover = row.cover || ''
      this.editData.category = row.category || ''
    },
    ClickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除该帮助条目？').then(function () {
        that.HelpCenterDelete(row.id)
      })
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    HelpCenterList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.question = that.queryData.question
      data.answer = that.queryData.answer
      data.category = that.queryData.category
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('HELP_CENTER', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    HelpCenterNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.question = that.queryData.question
      data.answer = that.queryData.answer
      data.category = that.queryData.category
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    HelpCenterInsert: function () {
      var that = this
      if (!that.addData.question) {
        that.$message.error('请输入问题')
        return
      }
      if (!that.addData.answer) {
        that.$message.error('请输入回答')
        return
      }
      if (!that.addData.category) {
        that.$message.error('请选择分类')
        return
      }
      var data = Vue.prototype.FunGetBaseSignData()
      data.question = that.addData.question
      data.answer = that.addData.answer
      data.cover = that.addData.cover
      data.category = that.addData.category
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.HelpCenterList()
            that.HelpCenterNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    HelpCenterUpdate: function () {
      var that = this
      if (!that.editData.question) {
        that.$message.error('请输入问题')
        return
      }
      if (!that.editData.answer) {
        that.$message.error('请输入回答')
        return
      }
      if (!that.editData.category) {
        that.$message.error('请选择分类')
        return
      }
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.question = that.editData.question
      data.answer = that.editData.answer
      data.cover = that.editData.cover
      data.category = that.editData.category
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.HelpCenterList()
            that.HelpCenterNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    HelpCenterDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_HelpCenterDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.HelpCenterList()
            that.HelpCenterNum()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }

      return true
    },
    handleAddUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)

      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'

      // 添加文件
      formData.append('file', options.file)

      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/covers/')

      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          that.addData.cover = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败')
        options.onError(error)
      })
    },
    handleEditUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)

      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'

      // 添加文件
      formData.append('file', options.file)

      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/covers/')

      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          that.editData.cover = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败')
        options.onError(error)
      })
    },
    getImageUrl (url) {
      if (!url) return ''
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  },
  watch: {
    dialogI18n (val) {
      if (!val) {
        this.loadTranslations('HELP_CENTER', this.dataList, 'id')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  HelpCenterManagement · 运动主题设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.help-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 文字辅助区 */
.text-muted {
  color: var(--aptus-text-muted);
}

.text-secondary {
  color: var(--aptus-text-secondary);
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 帮助表格 */
.help-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .col-tag .cell {
    overflow: visible;
    text-overflow: clip;
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .help-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}

/* 封面上传 */
.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: var(--aptus-primary);
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: var(--aptus-text-muted);
  margin-top: 8px;
}
</style>
